import React, { useState, useEffect } from "react";
import axios from "axios";

const useApi = url => {
	const [data, setData] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [isError, setIsError] = useState(false);

	async function fetchData() {
		setIsLoading(true);

		try {
			const response = await axios(url);
			setData(response.data);
		} catch (error) {
			console.log('useApi Hook said error: ', error);
			setIsError(true);
		}
		
		setIsLoading(false);
	}

	useEffect(() => {
		fetchData();
		return () => {
			// do nothing ...
		};
	}, [url]);

	return { data, isLoading, isError };
}

export default useApi;